import { FC } from 'react';
import { FormProps } from './Form.types';
import { getClasses } from '@/_utils/classnames';

export const Form: FC<FormProps> = (props) => {
  const formClasses: string = getClasses(
    'flex flex-column gap-4',
    props.className,
  );

  return (
    <>
      <form {...props} className={formClasses} />
    </>
  );
};
